import { useCallback, useEffect, useState } from "react";
import { Map, MousePointerClick, MailCheck, MailX, Percent, PanelTop } from "lucide-react";
import { adminApi } from "@/lib/api";

const PERIODS = [["7d", "Ultimi 7 giorni"], ["test", "Dal lancio del test"], ["all", "Totale"]];

const Stat = ({ id, icon: Icon, label, value, sub }) => (
  <div data-testid={id} className="rounded-3xl border border-emerald-100 bg-white p-6">
    <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-gray-500"><Icon className="h-4 w-4 text-emerald-600" />{label}</p>
    <p className="mt-3 font-display text-3xl font-extrabold text-gray-900">{value}</p>
    {sub && <p className="mt-1 text-xs text-gray-500">{sub}</p>}
  </div>
);

export const FunnelPanel = ({ tick }) => {
  const [period, setPeriod] = useState("7d");
  const [f, setF] = useState(null);
  const load = useCallback(() => adminApi.funnel(period).then(setF).catch(() => null), [period]);
  useEffect(() => { load(); }, [load, tick]);
  const start = f?.test_started_at ? new Date(f.test_started_at).toLocaleDateString("it-IT") : "—";
  return (
    <div data-testid="admin-funnel" className="mb-10">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="font-display text-xl font-semibold text-gray-900">Test preventivo via email</p>
          <p className="text-sm text-gray-500">Test iniziato il {start} · abbandono = pop-up chiuso o clic senza invio entro 30 minuti</p>
        </div>
        <div className="flex gap-2">
          {PERIODS.map(([k, l]) => (
            <button key={k} data-testid={`funnel-period-${k}`} onClick={() => setPeriod(k)}
              className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors ${period === k ? "bg-emerald-600 text-white" : "bg-white text-gray-600 ring-1 ring-emerald-100 hover:bg-emerald-50"}`}>{l}</button>
          ))}
        </div>
      </div>
      {f && (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
          <Stat id="funnel-generated" icon={Map} label="Itinerari generati" value={f.generated} />
          <Stat id="funnel-popups" icon={PanelTop} label="Pop-up mostrati" value={f.popups_shown} sub={`${f.popups_closed} chiusi senza email`} />
          <Stat id="funnel-clicked" icon={MousePointerClick} label='Clic "Ricevi via email"' value={f.clicked} sub="itinerari distinti" />
          <Stat id="funnel-completed" icon={MailCheck} label="Richieste completate" value={f.completed} sub={`${f.emails_sent} email inviate · ${f.completed_popup} dal pop-up`} />
          <Stat id="funnel-abandoned" icon={MailX} label="Richieste abbandonate" value={f.abandoned} sub="pop-up chiuso o clic senza invio entro 30 min" />
          <Stat id="funnel-rate" icon={Percent} label="Completate / generati" value={`${String(f.completion_rate).replace(".", ",")}%`} sub="itinerari del periodo inviati via email" />
        </div>
      )}
    </div>
  );
};
